import { render } from "./LeaderBoard.vue?vue&type=template&id=1c2a0104&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"

import "./LeaderBoard.vue?vue&type=style&index=0&id=1c2a0104&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2a0104"]])

export default __exports__